import Script from 'next/script';
import { FC } from 'react';
import { isDev } from 'models/conent';
import { Consent } from './consent';

interface Props {
  consent: Consent | null;
}

// Trackers that set their own cookies, mounted only once the matching
// category is accepted. GTM is not here: it always loads and is held back by
// Consent Mode (see the bootstrap in `_OldDesign/header.tsx`).
const ConsentScripts: FC<Props> = ({ consent }) => {
  const hotjarId = isDev ? 3669197 : 3197886;

  return (
    <>
      {consent?.marketing ? (
        <Script
          id="facebook-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `!function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '796368261118863');
              fbq('track', 'PageView');`,
          }}
        />
      ) : null}

      {consent?.analytics ? (
        <Script
          id="hotjar-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
              (function(h,o,t,j,a,r){
                  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                  h._hjSettings={hjid:${hotjarId},hjsv:6};
                  a=o.getElementsByTagName('head')[0];
                  r=o.createElement('script');r.async=1;
                  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                  a.appendChild(r);
              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `,
          }}
        />
      ) : null}
    </>
  );
};

export default ConsentScripts;
